<div class="card">
  <p><ng-content></ng-content></p>
</div>
